import Image from 'next/image';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { APPLICATION_LINK, FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
const TransactionEmpty: FC = () => {
  const router = useRouter();
  return <div className="my-auto flex h-full flex-col items-center justify-center" data-sentry-component="TransactionEmpty" data-sentry-source-file="TransactionEmpty.tsx">
      <div className="mx-auto flex justify-center">
        <Image src={`${FILE_BROWSER_URL}/img/subscription.webp`} width={320} height={190} alt="nodata" data-sentry-element="Image" data-sentry-source-file="TransactionEmpty.tsx" />
      </div>
      <div className="mb-3 text-center text-lg font-bold">هیچ تراکنشی ثبت نشده است</div>
      <div className="mx-auto max-w-[450px] text-center text-blackThree">
        با خرید اشتراک‌های تک‌درس، می‌توانید به محتوای هر دوره که نیاز دارید دسترسی پیدا کنید و یادگیری را دقیقاً در موضوعات
        دلخواهتان پیش ببرید. همین حالا اولین اشتراک خود را تهیه کنید و به دانش جدیدی دست یابید!{' '}
      </div>
      <div className=" flex w-full max-w-[450px] flex-row gap-4">
        <Button onClick={() => router.push(`${APPLICATION_LINK}/store/`)} className="mr-0 mt-8 w-full  " variant="shadow" color="ORANGE_BOLD" size="middle" radius="round" bold data-sentry-element="Button" data-sentry-source-file="TransactionEmpty.tsx">
          خرید تک درس
        </Button>
        <Button onClick={() => router.push(LINKS.SUBSCRIPTION.MAIN)} className="mr-0 mt-8 w-full  " variant="shadow" color="BLUE_BOLD" size="middle" radius="round" bold data-sentry-element="Button" data-sentry-source-file="TransactionEmpty.tsx">
          خرید اشتراک
        </Button>
      </div>
    </div>;
};
export default TransactionEmpty;